import { useMemo, useCallback, useState } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useRouteMatch } from "react-router-dom";
import { drawerWidth } from "styles/constants";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pageContent: {
      padding: 5,
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        padding: "1em",
      },
    },
  }),
);

const useDashboard = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const [t] = useTypedTranslations();

  const match = useRouteMatch<{
    merchantId: string;
    sectionSlug: string;
  }>("/merchants/:merchantId/:sectionSlug/");

  const [sectionSlug, merchantId] = useMemo(() => {
    const params = match?.params ?? {
      sectionSlug: "",
      merchantId: "",
    };
    return [params.sectionSlug ?? "events", params.merchantId ?? ""];
  }, [match]);

  const [isDrawerOpen, setDrawerState] = useState(false);

  const handleDrawerToggle = useCallback(() => {
    setDrawerState(!isDrawerOpen);
  }, [isDrawerOpen]);

  return {
    styles,
    classes,
    atomicStyles,
    t,
    sectionSlug,
    merchantId,
    isDrawerOpen,
    handleDrawerToggle,
  };
};

export { useDashboard as default };
